module.exports = __webpack_public_path__ + "img/rate_inferior_b.547ef83d.png";